/** The curves and colour ramps an emitter's simulation reads, resolved and loaded as a hook. */
import { useCallback, useMemo } from 'react';
import { resolveGradient } from '../../../resources/textures/gradienttexture2d/decode';
import { useLoadedFiles } from '../../../resources/useLoadedFiles';
import { useSceneResources } from '../../../r3f/SceneResourcesContext';
import { paramCurveReferences, particleFiles, resolveParticleCurve, resolveParticleCurves, } from './sceneResources';
/** The resources `references` name in the scene, which re-resolve as each `.tres` loads. */
export function useParticleResources(references) {
    const pools = useSceneResources();
    const { params, colorRamp, colorInitialRamp } = references;
    // The strings, not the `scaleCurves` object: a caller builds that object on each render.
    const scaleX = references.scaleCurves?.x;
    const scaleY = references.scaleCurves?.y;
    const scaleZ = references.scaleCurves?.z;
    // Every named reference once, so the files to load and the resolve read one list.
    const named = useMemo(() => ({
        scaleX,
        scaleY,
        scaleZ,
        colorRamp,
        colorInitialRamp,
    }), [scaleX, scaleY, scaleZ, colorRamp, colorInitialRamp]);
    const planFiles = useCallback(() => particleFiles([...paramCurveReferences(params), ...Object.values(named)], pools), [params, named, pools]);
    const { loadedFile } = useLoadedFiles(planFiles);
    return useMemo(() => {
        const curve = (reference) => resolveParticleCurve(reference, pools, loadedFile);
        const gradient = (reference) => resolveGradient(reference, pools, loadedFile);
        return {
            curves: resolveParticleCurves(params, pools, loadedFile),
            scaleCurves: { x: curve(named.scaleX), y: curve(named.scaleY), z: curve(named.scaleZ) },
            colorRamp: gradient(named.colorRamp),
            colorInitialRamp: gradient(named.colorInitialRamp),
        };
    }, [params, named, pools, loadedFile]);
}
//# sourceMappingURL=useParticleResources.js.map